import React from "react";
import {
  PopupContent,
  PopupHeader,
} from "../../../../../components/ui/popup/common";
import ModalNew from "../../../../../components/ui/popup/Modal";

const Prepare8879ErrorModal = ({ isOpen, error, onClose, onRetry }) => {
  if (!isOpen || !error) return null;

  return (
    <ModalNew style={{ maxWidth: "450px" }}>
      <PopupHeader
        title="Prepare Form 8879"
        setOpenState={onClose}
        icon={`${process.env.PUBLIC_URL}/images/icons/doc_blue_popup.svg`}
        variant="compact"
      />
      <PopupContent>
        <div style={{ textAlign: "center" }}>
          <p style={{ color: "#850000", marginBottom: "20px" }}>{error}</p>
          <div
            style={{
              display: "flex",
              gap: "12px",
              justifyContent: "center",
            }}
          >
            <button
              type="button"
              className="cta-button secondary"
              onClick={onClose}
            >
              Close
            </button>
            <button
              type="button"
              className="cta-button primary"
              onClick={onRetry}
            >
              Try Again
            </button>
          </div>
        </div>
      </PopupContent>
    </ModalNew>
  );
};

export default Prepare8879ErrorModal;
